import React from 'react';

const NewPreloader = () => {
  // Inline style for the wrapper
  const wrapperStyle = {
    display: 'inline-block',
    // if you want to center it:
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  };

  // Inline style for the SVG to spin around its center
  const svgStyle = {
    animation: 'spin 1s linear infinite',
    transformOrigin: '50% 50%',
  };

  return (
    <div style={wrapperStyle}>
      {/* Inject keyframes directly */}
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      <svg
        style={svgStyle}
        width="51"
        height="52"
        viewBox="0 0 51 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.4998 5.28125V10.5938M25.4998 38.75V47.25M12.4789 26H5.18726M44.7706 26H41.6456M38.9521 39.7214L37.4789 38.2188M39.3835 12.0085L36.4373 15.0137M10.753 41.0417L16.6456 35.0312M11.1845 11.5684L15.6039 16.0762"
          stroke="#00A293"
          strokeWidth="4.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default NewPreloader;
